import { omniAtom } from "src/utils/atoms";
import type { ResponseGetMerchantSettings } from "@CommonApi/merchant-settings";
import { FeatureFlag, ReportSettings } from "./types";

export const featureFlagsAtom = omniAtom({
  key: "featureFlags",
  value: null as null | Record<FeatureFlag, boolean>,
});

export const settingsAtom = omniAtom({
  key: "settings",
  value: null as null | ReportSettings,
});

export const merchantSettingsAtom = omniAtom<ResponseGetMerchantSettings | null>({
  key: "merchantSettings",
  value: null,
});

export const merchantSettingsLoadedAtom = omniAtom({
  key: "merchantSettingsLoaded",
  value: false,
});

export const merchantSettingsLoadFailedAtom = omniAtom({
  key: "merchantSettingsLoadFailed",
  value: false,
});
